import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/api`;

const getAuthHeaders = () => {
  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  const user = storedUser ? JSON.parse(storedUser) : null;

  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("jwt");

  const headers = {};

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  if (user?.id) {
    headers["X-User-Id"] = String(user.id);
  }

  return headers;
};

export const fetchCampaigns = async () => {
  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  const user = storedUser ? JSON.parse(storedUser) : null;

  if (!user?.id) {
    throw new Error("User session not found. Please login again.");
  }

  const response = await axios.get(`${API_URL}/campaigns`, {
    headers: getAuthHeaders(),
  });

  return response.data;
};

export const createCampaign = async (
  campaignData,
  refFile = null,
  jobDetailFile = null
) => {
  const formData = new FormData();

  Object.keys(campaignData).forEach((key) => {
    const value = campaignData[key];

    if (key === "brand_ids") {
      formData.append("brand_ids", JSON.stringify(value));
    } else if (
      value !== null &&
      value !== undefined &&
      value !== ""
    ) {
      formData.append(key, value);
    }
  });

  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  const user = storedUser ? JSON.parse(storedUser) : null;

  if (!user?.id) {
    throw new Error("User session not found. Please login again.");
  }

  formData.append("added_by", String(user.id));

  if (refFile) {
    formData.append("ref_file", refFile);
  }

  if (jobDetailFile) {
    formData.append("job_detail_file", jobDetailFile);
  }

  const response = await axios.post(`${API_URL}/campaigns`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const updateCampaign = async (
  campaignId,
  title,
  brandId
) => {
  const formData = new FormData();

  if (title !== undefined && title !== null) {
    formData.append("title", title);
  }

  if (brandId !== undefined && brandId !== null) {
    formData.append("brand_id", String(brandId));
  }

  const response = await axios.put(
    `${API_URL}/campaigns/${campaignId}`,
    formData,
    {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};